import React from 'react';
import Image from 'next/image';

const ValuePropositionMachineLearning = () => {
    return (
        <div className="section-py relative bg-black">
            <div className="bg-agriculture-numbers">
                <video playsInline autoPlay muted loop className="aimlvideo h-[385px] counter-overlay-value" width="100%">
                    <source src="media/aiml-section.mp4" type="video/mp4" />
                </video>
            </div>
            <div className="container xl:container mx-auto relative z-[1]">
                <div className="row grid lg:grid-cols-12 mb-10">
                    <div className="lg:col-span-8 grid">
                        <h2 className="text-white mb-2.5">Value Proposition</h2>
                        <p className="dark:text-[#D7DEE5] mb-0">
                            Accelerate digital transformation with production-ready predictive models, classification systems, and
                            forecasting solutions designed for agility and scalability. We deliver fast proofs-of-concept (POCs),
                            bridge the gap between experimentation and enterprise ML solutions, and optimize every stage of your
                            ML lifecycle, from model training and validation to deployment and retraining. Our focus is on
                            maximizing ML model accuracy and business outcomes.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 grid-cols-1">
                    <div>
                        <div className="voice-generator-box mb-2">
                            <Image
                                src="/img/llms-aiml/svg/ic_theproblemwesolve.svg"
                                alt="supply-chain-changing"
                                title="supply-chain-changing"
                                width={36}
                                height={36}
                                loading="lazy"
                            />
                        </div>
                        <p className="text-white mb-2 font-bold">Problem we solve</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Inaccurate forecasts, slow manual decision-making, limited data-driven insights, and lost business
                            opportunities due to a lack of predictive modeling capabilities.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                            <Image
                                src="/img/llms-aiml/svg/ic_ourcorecapabilities.svg"
                                alt="supply-chain-changing"
                                title="supply-chain-changing"
                                width={36}
                                height={36}
                                loading="lazy"
                            />
                        </div>
                        <p className="text-white mb-2 font-bold">Core capabilities</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            End-to-end custom ML development, predictive modeling for business forecasting, advanced data
                            preparation and feature engineering, real-time anomaly detection systems, scalable model optimization
                            techniques, and robust enterprise ML pipelines.
                        </p>
                    </div>
                    <div>
                        <div className="voice-generator-box mb-2">
                            <Image
                                src="/img/llms-aiml/svg/ic_outcomeexamples.svg"
                                alt="supply-chain-changing"
                                title="supply-chain-changing"
                                width={36}
                                height={36}
                                loading="lazy"
                            />
                        </div>
                        <p className="text-white mb-2 font-bold">Outcomes</p>
                        <p className="text-white opacity-[0.8] mb-0 fs-md">
                            Up to 85% prediction accuracy, 40% reduction in operational costs, 3x faster decision cycles, and 60%
                            decrease in manual processing time.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ValuePropositionMachineLearning;
